import { List } from 'immutable'
import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { ImageSize, Link } from "../../../../cms/blocks/types.gen"
import { getClassName } from "../../../../cms/blocks/utils.gen"
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types"
import { CMSState } from '../../../drupalPage/state'
import { QuoteSlideProps, QuotesBlock } from "./quotes"

export type quotesBlockProps = {
  index: number
  field_title: string
  field_quote_items: List<quoteItemBlockProps>
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type quoteItemBlockProps = {
  field_author_name: string
  field_function: string | null
  field_image?: ParsedMediaImage
  image?: number
  image_alt?: string
  image_size?: ImageSize
  field_link: Link
  field_quote: string
}

export type quotesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function quotesBlock(
  props: quotesBlockProps,
  options?: { style: quotesBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (cmsState: CMSState) =>
    fromJSX(
      _ => {
        return (
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('quotes', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.index}`}
            className={"container-fluid bg-light my-5"}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            {QuotesBlock(
              {
                isStyleguide: false,
                title: props.field_title,
                cmsState: cmsState,
                quotes: props.field_quote_items
                  .map((e, i) =>
                    (
                      {
                        person: e!.field_author_name,
                        person_function: e!.field_function,
                        quote: e!.field_quote,
                        field_image: e!.field_image,
                        btn: e?.field_link?.title != undefined && 
                             e?.field_link?.url != undefined ?
                        {
                          label: e!.field_link.title,
                          url: e!.field_link.url
                        } : undefined,
                        image: e!.image,
                        image_alt: e.image_alt,
                        image_size: e.image_size,

                      }
                    ) as QuoteSlideProps
                  ).toArray(),
              }
            )}
          </InView>
        )
      },
    )
}
